// import React, { useCallback, useEffect, useState } from 'react';
// import { Form, Button, Table, Modal } from 'react-bootstrap';
// import Layout from '../../utils/layout';
// import useStore from '../../hooks/useStore';
// import { toJS } from "mobx";
// import { useNavigate } from 'react-router-dom';
// import { observer } from "mobx-react";

// const TotalProductionPage =() => {
//   const [show, setShow] = useState(false);
//   const [form, setForm] = useState({
//     year: '',
//     unit: 'MT',
//     currentValue: '',
//     targetValue: '',
//     comment: '',
//     attachment: null,
//     frequencyType: 'Yearly',  
//     frequencyMonth: '',  
//   });
//   const [data, setData] = useState([]);
//   const [details, setDetails] = useState(null);
//   const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
//   const navigate = useNavigate();
//   const [editingId, setEditingId] = useState(null);
//     const [editForm, setEditForm] = useState({
//     frequencyMonth: '',
//     currentValue: '',
//     targetValue: '',
//     comment: ''
//     });


//   const {
//     companyStore: { companyUnit, fetchUnits, units },
//     userStore: { userData, user }
//   } = useStore();

//   useEffect(() => {
//     fetchUnits();
//   }, [fetchUnits]);

// //   useEffect(() => {
// //     fetchData();
// //     fetchDetails();
// //   }, [yearFilter,companyUnit]);
// //   useEffect(() => {
// //     setData([]);
// //     setDetails(null);
// //   }, [companyUnit]);



//   const fetchData = async () => {
//     const token = localStorage.getItem("token");
//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_BASE_URL}total-production/list/${user?.id}?year=${yearFilter}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       const result = await res.json();
//       if (result.status) {
//         setData(result.data || []);
//       }
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     }
//   };


// //   const fetchDetails = async () => {
// //     const token = localStorage.getItem("token");
// //     try {
// //       const res = await fetch(
// //         `${process.env.REACT_APP_BASE_URL}total-production/details?companyUnit=${companyUnit}&year=${yearFilter}`,
// //         {
// //           headers: { Authorization: `Bearer ${token}` },
// //         }
// //       );
// //       console.log("response", res);
// //       const result = await res.json();
// //       if (result.status) {
// //         setDetails(result.data);
// //       } else {
// //         setDetails(null);
// //       }
// //     } catch (err) {
// //       console.error("Error fetching detail data:", err);
// //       setDetails(null);
// //     }
// //   };

  
// const fetchDetails = useCallback(async () => {
//     const token = localStorage.getItem("token");
//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_BASE_URL}total-production/details?companyUnit=${companyUnit}&year=${yearFilter}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       const result = await res.json();
//       if (result.status) {
//         setDetails(result.data);
//       } else {
//         setDetails(null);
//       }
//     } catch (err) {
//       console.error("Error fetching detail data:", err);
//       setDetails(null);
//     }
//   }, [yearFilter, companyUnit]);


//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     setForm({
//       ...form,
//       [name]: files ? files[0] : value,
//     });
//   };


//   const convertToBase64 = (file) =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = (error) => reject(error);
//     });

//   const handleSave = async () => {
//     const unitId = toJS(units)?.find((u) => u.shortName === form.unit)?.id || null;

//     if (!unitId || !form.year || !form.currentValue || !form.targetValue) {
//       alert("Please fill all required fields.");
//       return;
//     }

//     if (form.frequencyType === "Monthly" && !form.frequencyMonth) {
//         alert("Please select a month for Monthly frequency.");
//         return;
//       }
      

//     const attachmentBase64 = form.attachment ? await convertToBase64(form.attachment) : null;

//     // const formData = new FormData();
//     // formData.append("year", form.year);
//     // formData.append("unit", form.unit);
//     // formData.append("companyId", user?.id);
//     // formData.append("currentValue", form.currentValue);
//     // formData.append("targetValue", form.targetValue);
//     // formData.append("comment", form.comment);
//     // formData.append("companyUnit", companyUnit);
//     // formData.append("createdBy", user?.id);
//     // if (form.attachment) {
//     //   formData.append("attachment", form.attachment);
//     // }


//     const payload = {
//         year: form.year,
//         unit: form.unit,
//         companyId: user?.id,
//         companyUnit: companyUnit,
//         currentValue: form.currentValue,
//         targetValue: form.targetValue,
//         comment: form.comment,
//         frequencyType: form.frequencyType,               // ✅ added
//          frequencyMonth: form.frequencyType === "Monthly" ? form.frequencyMonth : null,
//         createdBy: user?.id,
//         attachments: attachmentBase64 ? [attachmentBase64] : [],
//       };

//     const token = localStorage.getItem("token");

//     try {
//       const response = await fetch(`${process.env.REACT_APP_BASE_URL}total-production/save`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body:JSON.stringify(payload),
//       });

//       const result = await response.json();

//       if (response.ok && result.status) {
//         alert(result.message);
//         window.location.href = "/company/totalProduction";
//       } else {
//         alert(result.message || "Failed to save data");
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       alert("An error occurred while saving. Check console for details.");
//     }
//   };


//   const startEditing = (data) => {
//     setEditingId(data.id);
//     setEditForm({
//       frequencyMonth: data.frequencyMonth || '',
//       currentValue: data.currentValue,
//       targetValue: data.targetValue,
//       comment: data.comment || '',
//     });
//   };
  
//   const handleEditChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleUpdate = async (id) => {
//     const token = localStorage.getItem("token");
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}total-production/update/${id}`, {
//         method: 'PUT',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ ...editForm }),
//       });
  
//       const result = await res.json();
//       if (result.status) {
//         alert('Updated successfully');
//         setEditingId(null);
//         fetchDetails();
//       } else {
//         alert(result.msg || 'Failed to update');
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       alert('Something went wrong while updating');
//     }
//   };


//   const handleDelete = async (id) => {
//     const token = localStorage.getItem("token");
//     if (!window.confirm("Are you sure you want to delete this entry?")) return;
  
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}total-production/delete/${id}`, {
//         method: 'DELETE',
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const result = await res.json();
//       if (result.status) {
//         alert('Deleted successfully');
//         fetchDetails();
//       } else {
//         alert(result.msg || 'Failed to delete');
//       }
//     } catch (err) {
//       console.error('Delete error:', err);
//     }
//   };
    

  
//   useEffect(() => {
//     if (!show) {
//       setForm({
//         year: '',
//         unit: 'MT',
//         currentValue: '',
//         targetValue: '',
//         comment: '',
//         attachment: null,
//         frequencyType: 'Yearly',
//         frequencyMonth: '',
//       });
//     }
//   }, [show]);
  

//   useEffect(() => {

//     console.log("Effect running with companyUnit:", companyUnit, "year:", yearFilter);
//     // If companyUnit changes, reset data first
//     if (companyUnit) {
//       setData([]);
//       setDetails(null);
      
//       fetchDetails();
//     }
//   }, [companyUnit, yearFilter,fetchDetails]);
  

//   return (
//     <Layout>
//       <div className="container mt-4">
//         <div className="d-flex justify-content-between align-items-center mb-3">
//           <h5>Total Production Quantity</h5>
//           <Button variant="primary" onClick={() => setShow(true)}>
//             Add Total Production Quantity
//           </Button>
//         </div>

//         <Form.Select
//           className="mb-3"
//           value={yearFilter}
//           onChange={(e) => setYearFilter(e.target.value)}
//         >
//           {Array.from({ length: 5 })
//             .map((_, i) => new Date().getFullYear() - i)
//             .map((v) => (
//               <option key={v} value={v}>{`CY ${v}`}</option>
//             ))}
//         </Form.Select>
//         {/* {details && (
//   <>
//     <h5 className="mt-4">Details for CY {yearFilter}</h5>
//     <Table bordered>
//       <thead>
//         <tr>
//           <th>Title</th>
//           <th>Frequency</th>
//             <th>Month</th>
//           <th>Unit</th>
//           <th>Current Value</th>
//           <th>Target Value</th>
//           <th>Comment</th>
//           <th>Attachment</th>
//         </tr>
//       </thead>
//       <tbody>
//         <tr>
//           <td>Total Production Quantity</td>
//           <td>{details.frequencyType}</td>
//             <td>
//             {details.frequencyType === "Monthly"
//                 ? new Date(0, details.frequencyMonth - 1).toLocaleString('default', { month: 'long' })
//                 : "N/A"}
//             </td>

//           <td>{details.unitName || 'MT'}</td>
//           <td>{details.currentValue}</td>
//           <td>{details.targetValue}</td>
//           <td>{details.comment || 'N/A'}</td>
//           <td>
//           {details?.url?.length > 0 ? (
//   details.url.map((item, index) => (
//     <div key={index} className="mb-1">
      
//       <a  href={item.url}
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         Download {item.name || `Attachment ${index + 1}`}
//       </a>
//     </div>
//   ))
// ) : (
//   <div>N/A</div>
// )}

// </td>

//         </tr>
//       </tbody>
//     </Table>
//   </>
// )} */}



// {Array.isArray(details) && details.length > 0 && (
//   <>
//     <Table bordered>
//       <thead>
//         <tr>
//           <th>Title</th>
//           <th>Frequency</th>
//           <th>Month</th>
//           <th>Unit</th>
//           <th>Current Value</th>
//           <th>Target Value</th>
//           <th>Comment</th>
//           <th>Attachment</th>
//           <th>Actions</th>

//         </tr>
//       </thead>
//       {/* <tbody>
//         {details.map((item, index) => (
//           <tr key={index}>
//             <td>Total Production Quantity</td>
//             <td>{item.frequencyType}</td>
//             <td>
//               {item.frequencyType === "Monthly"
//                 ? new Date(0, item.frequencyMonth - 1).toLocaleString("default", { month: "long" })
//                 : "N/A"}
//             </td>
//             <td>{item.unitName}</td>
//             <td>{item.currentValue}</td>
//             <td>{item.targetValue}</td>
//             <td>{item.comment || "N/A"}</td>
//             <td>
//               {item?.url?.length > 0 ? (
//                 item.url.map((att, i) => (
//                   <div key={i}>
//                     <a href={att.url} target="_blank" rel="noopener noreferrer">
//                       {att.name || `Attachment ${i + 1}`}
//                     </a>
//                   </div>
//                 ))
//               ) : (
//                 "N/A"
//               )}
//             </td>
//             <td>
//         {editingId === details.id ? (
//             <>
//             <Button size="sm" variant="success" onClick={() => handleUpdate(details.id)}>Save</Button>{' '}
//             <Button size="sm" variant="secondary" onClick={() => setEditingId(null)}>Cancel</Button>
//             </>
//         ) : (
//             <>
//             <Button size="sm" variant="primary" onClick={() => startEditing(details)}>Edit</Button>{' '}
//             <Button size="sm" variant="danger" onClick={() => handleDelete(details.id)}>Delete</Button>
//             </>
//         )}
//         </td>

//                 </tr>
//         ))}
//       </tbody> */}

// <tbody>
//   {details.map((item, index) => (
//     <tr key={index}>
//       <td>Total Production Quantity</td>
//       <td>{item.frequencyType}</td>
//       <td>
//         {editingId === item.id ? (
//           <Form.Select
//             name="frequencyMonth"
//             value={editForm.frequencyMonth}
//             onChange={handleEditChange}
//           >
//             {[...Array(12).keys()].map((m) => (
//               <option key={m + 1} value={m + 1}>
//                 {new Date(0, m).toLocaleString("default", { month: "long" })}
//               </option>
//             ))}
//           </Form.Select>
//         ) : item.frequencyType === "Monthly" ? (
//           new Date(0, item.frequencyMonth - 1).toLocaleString("default", { month: "long" })
//         ) : (
//           "N/A"
//         )}
//       </td>
//       <td>{item.unitName}</td>

//       <td>
//         {editingId === item.id ? (
//           <Form.Control
//             type="number"
//             name="currentValue"
//             value={editForm.currentValue}
//             onChange={handleEditChange}
//           />
//         ) : (
//           item.currentValue
//         )}
//       </td>
//       <td>
//         {editingId === item.id ? (
//           <Form.Control
//             type="number"
//             name="targetValue"
//             value={editForm.targetValue}
//             onChange={handleEditChange}
//           />
//         ) : (
//           item.targetValue
//         )}
//       </td>
//       <td>
//         {editingId === item.id ? (
//           <Form.Control
//             type="text"
//             name="comment"
//             value={editForm.comment}
//             onChange={handleEditChange}
//           />
//         ) : (
//           item.comment || "N/A"
//         )}
//       </td>
//       <td>
//         {item?.url?.length > 0 ? (
//           item.url.map((att, i) => (
//             <div key={i}>
//               <a href={att.url} target="_blank" rel="noopener noreferrer">
//                 {att.name || `Attachment ${i + 1}`}
//               </a>
//             </div>
//           ))
//         ) : (
//           "N/A"
//         )}
//       </td>
//       <td>
//         {editingId === item.id ? (
//           <>
//             <Button size="sm" variant="success" onClick={() => handleUpdate(item.id)}>Save</Button>{" "}
//             <Button size="sm" variant="secondary" onClick={() => setEditingId(null)}>Cancel</Button>
//           </>
//         ) : (
//           <>
//             <Button size="sm" variant="primary" onClick={() => startEditing(item)}>Edit</Button>{" "}
//             <Button size="sm" variant="danger" onClick={() => handleDelete(item.id)}>Delete</Button>
//           </>
//         )}
//       </td>
//     </tr>
//   ))}
// </tbody>

//     </Table>
//   </>
// )}


//         <Modal show={show} onHide={() => setShow(false)} size="lg">
//           <Modal.Header closeButton>
//             <Modal.Title>Add Total Production Quantity</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="d-flex gap-3 mb-4">
//               <Form.Group>
//               <Form.Group>
//                 <Form.Label>Frequency Type</Form.Label>
//                 <Form.Select name="frequencyType" value={form.frequencyType} onChange={handleChange}>
//                     <option value="Yearly">Yearly</option>
//                     <option value="Monthly">Monthly</option>
//                 </Form.Select>
//                 </Form.Group>
//                 <Form.Label>Year</Form.Label>
//                 <Form.Select name="year" value={form.year} onChange={handleChange}>
//                   <option value="">Select Year</option>
//                   {Array.from({ length: 5 })
//                     .map((_, i) => new Date().getFullYear() - i)
//                     .map((v) => (
//                       <option key={v} value={v}>{`CY ${v}`}</option>
//                     ))}
//                 </Form.Select>
//               </Form.Group>

//               {form.frequencyType === "Monthly" && (
//                 <Form.Group>
//                     <Form.Label>Month</Form.Label>
//                     <Form.Select name="frequencyMonth" value={form.frequencyMonth} onChange={handleChange}>
//                     {[
//                         "January", "February", "March", "April", "May", "June",
//                         "July", "August", "September", "October", "November", "December"
//                     ].map((month, index) => (
//                         <option key={index} value={index + 1}>{month}</option>
//                     ))}
//                     </Form.Select>
//                 </Form.Group>
//                 )}
//                             <Form.Group>
//                 <Form.Label>Unit</Form.Label>
//                 <Form.Select name="unit" value={form.unit} onChange={handleChange}>
//                   <option value="MT">MT</option>
//                 </Form.Select>
//               </Form.Group>
//             </div>

//             <Table bordered>
//               <thead>
//                 <tr>
//                   <th>Sr. No.</th>
//                   <th>Title</th>
//                   <th>Unit</th>
//                   <th>Current Value</th>
//                   <th>Target Value</th>
//                   <th>Comment</th>
//                   <th>Attachment</th>
                  
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>1</td>
//                   <td>Total Production Quantity</td>
//                   <td>MT</td>
//                   <td>
//                     <Form.Control
//                       type="number"
//                       name="currentValue"
//                       value={form.currentValue}
//                       onChange={handleChange}
//                     />
//                   </td>
//                   <td>
//                     <Form.Control
//                       type="number"
//                       name="targetValue"
//                       value={form.targetValue}
//                       onChange={handleChange}
//                     />
//                   </td>
//                   <td>
//                     <Form.Control
//                       type="text"
//                       name="comment"
//                       value={form.comment}
//                       onChange={handleChange}
//                     />
//                   </td>
//                   <td>
//                     <Form.Control
//                       type="file"
//                       name="attachment"
//                       onChange={handleChange}
//                     />
//                   </td>
//                 </tr>
//               </tbody>
//             </Table>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setShow(false)}>Cancel</Button>
//             <Button variant="primary" onClick={handleSave}>Save</Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </Layout>
//   );
// };

// export default observer(TotalProductionPage);


import React, { useCallback, useEffect, useState } from 'react';
import { Form, Button, Table, Modal } from 'react-bootstrap';
import Layout from '../../utils/layout';
import useStore from '../../hooks/useStore';
import { toJS } from "mobx";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";

const TotalProductionPage = () => {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({
    year: '',
    unit: 'MT',
    currentValue: '',
    targetValue: '',
    comment: '',
    attachment: null,
    frequencyType: 'Yearly',  
    frequencyMonth: '',  
  });
  const [data, setData] = useState([]);
  const [details, setDetails] = useState(null);
  const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
  const navigate = useNavigate();
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    frequencyMonth: '',
    currentValue: '',
    targetValue: '',
    comment: ''
  });

  const {
    companyStore: { companyUnit, fetchUnits, units },
    userStore: { userData, user }
  } = useStore();

  useEffect(() => {
    fetchUnits();
  }, [fetchUnits]);

  const fetchData = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}total-production/list/${user?.id}?year=${yearFilter}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const result = await res.json();
      if (result.status) {
        setData(result.data || []);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const fetchDetails = useCallback(async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}total-production/details?companyUnit=${companyUnit}&year=${yearFilter}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const result = await res.json();
      if (result.status) {
        setDetails(result.data);
      } else {
        setDetails(null);
      }
    } catch (err) {
      console.error("Error fetching detail data:", err);
      setDetails(null);
    }
  }, [yearFilter, companyUnit, user]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm({
      ...form,
      [name]: files ? files[0] : value,
    });
  };

  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleSave = async () => {
    const unitId = toJS(units)?.find((u) => u.shortName === form.unit)?.id || null;

    if (!unitId || !form.year || !form.currentValue || !form.targetValue) {
      alert("Please fill all required fields.");
      return;
    }

    if (form.frequencyType === "Monthly" && !form.frequencyMonth) {
      alert("Please select a month for Monthly frequency.");
      return;
    }
      
    const attachmentBase64 = form.attachment ? await convertToBase64(form.attachment) : null;

    const payload = {
      year: form.year,
      unit: form.unit,
      companyId: user?.id,
      companyUnit: companyUnit,
      currentValue: form.currentValue,
      targetValue: form.targetValue,
      comment: form.comment,
      frequencyType: form.frequencyType,
      frequencyMonth: form.frequencyType === "Monthly" ? form.frequencyMonth : null,
      createdBy: user?.id,
      attachments: attachmentBase64 ? [attachmentBase64] : [],
    };

    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}total-production/save`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok && result.status) {
        alert(result.message);
        handleClose();
        fetchDetails();
      } else {
        alert(result.message || "Failed to save data");
      }
    } catch (error) {
      console.error("API error:", error);
      alert("An error occurred while saving. Check console for details.");
    }
  };

  const startEditing = (data) => {
    setEditingId(data.id);
    setEditForm({
      frequencyMonth: data.frequencyMonth || '',
      currentValue: data.currentValue,
      targetValue: data.targetValue,
      comment: data.comment || '',
    });
  };
  
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async (id) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}total-production/update/${id}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ ...editForm }),
      });
  
      const result = await res.json();
      if (result.status) {
        alert('Updated successfully');
        setEditingId(null);
        fetchDetails();
      } else {
        alert(result.msg || 'Failed to update');
      }
    } catch (err) {
      console.error('Update error:', err);
      alert('Something went wrong while updating');
    }
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    if (!window.confirm("Are you sure you want to delete this entry?")) return;
  
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}total-production/delete/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      if (result.status) {
        alert('Deleted successfully');
        fetchDetails();
      } else {
        alert(result.msg || 'Failed to delete');
      }
    } catch (err) {
      console.error('Delete error:', err);
    }
  };
    
  // Clear form when modal closes
  useEffect(() => {
    if (!show) {
      setForm({
        year: '',
        unit: 'MT',
        currentValue: '',
        targetValue: '',
        comment: '',
        attachment: null,
        frequencyType: 'Yearly',
        frequencyMonth: '',
      });
    }
  }, [show]);
  
  // Fetch details when companyUnit or yearFilter changes
  useEffect(() => {
   // console.log("Effect running with companyUnit:", companyUnit, "year:", yearFilter);
    if (companyUnit) {
      setData([]);
      setDetails(null);
      fetchDetails();
    }
  }, [companyUnit, yearFilter, fetchDetails]);
  
  // Modal handlers
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <Layout>
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>Total Production Quantity</h5>
          <Button variant="primary" onClick={handleShow}>
            Add Total Production Quantity
          </Button>
        </div>

        <Form.Select
          className="mb-3"
          value={yearFilter}
          onChange={(e) => setYearFilter(e.target.value)}
        >
          {Array.from({ length: 5 })
            .map((_, i) => new Date().getFullYear() - i)
            .map((v) => (
              <option key={v} value={v}>{`CY ${v}`}</option>
            ))}
        </Form.Select>

        {Array.isArray(details) && details.length > 0 && (
          <>
            <Table bordered>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Frequency</th>
                  <th>Month</th>
                  <th>Unit</th>
                  <th>Current Value</th>
                  <th>Target Value</th>
                  <th>Comment</th>
                  <th>Attachment</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {details.map((item, index) => (
                  <tr key={index}>
                    <td>Total Production Quantity</td>
                    <td>{item.frequencyType}</td>
                    <td>
                      {editingId === item.id ? (
                        <Form.Select
                          name="frequencyMonth"
                          value={editForm.frequencyMonth}
                          onChange={handleEditChange}
                        >
                          {[...Array(12).keys()].map((m) => (
                            <option key={m + 1} value={m + 1}>
                              {new Date(0, m).toLocaleString("default", { month: "long" })}
                            </option>
                          ))}
                        </Form.Select>
                      ) : item.frequencyType === "Monthly" ? (
                        new Date(0, item.frequencyMonth - 1).toLocaleString("default", { month: "long" })
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>{item.unitName}</td>
                    <td>
                      {editingId === item.id ? (
                        <Form.Control
                          type="number"
                          name="currentValue"
                          value={editForm.currentValue}
                          onChange={handleEditChange}
                        />
                      ) : (
                        item.currentValue
                      )}
                    </td>
                    <td>
                      {editingId === item.id ? (
                        <Form.Control
                          type="number"
                          name="targetValue"
                          value={editForm.targetValue}
                          onChange={handleEditChange}
                        />
                      ) : (
                        item.targetValue
                      )}
                    </td>
                    <td>
                      {editingId === item.id ? (
                        <Form.Control
                          type="text"
                          name="comment"
                          value={editForm.comment}
                          onChange={handleEditChange}
                        />
                      ) : (
                        item.comment || "N/A"
                      )}
                    </td>
                    <td>
                      {item?.url?.length > 0 ? (
                        item.url.map((att, i) => (
                          <div key={i}>
                            <a href={att.url} target="_blank" rel="noopener noreferrer">
                              {att.name || `Attachment ${i + 1}`}
                            </a>
                          </div>
                        ))
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      {editingId === item.id ? (
                        <>
                          <Button size="sm" variant="success" onClick={() => handleUpdate(item.id)}>Save</Button>{" "}
                          <Button size="sm" variant="secondary" onClick={() => setEditingId(null)}>Cancel</Button>
                        </>
                      ) : (
                        <>
                          <Button size="sm" variant="primary" onClick={() => startEditing(item)}>Edit</Button>{" "}
                          <Button size="sm" variant="danger" onClick={() => handleDelete(item.id)}>Delete</Button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        {/* Modal using react-bootstrap */}
        <Modal 
          show={show} 
          onHide={handleClose} 
          size="lg" 
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Total Production Quantity</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex gap-3 mb-4">
              <Form.Group>
                <Form.Group>
                  <Form.Label>Frequency Type</Form.Label>
                  <Form.Select name="frequencyType" value={form.frequencyType} onChange={handleChange}>
                    <option value="Yearly">Yearly</option>
                    <option value="Monthly">Monthly</option>
                  </Form.Select>
                </Form.Group>
                <Form.Label>Year</Form.Label>
                <Form.Select name="year" value={form.year} onChange={handleChange}>
                  <option value="">Select Year</option>
                  {Array.from({ length: 5 })
                    .map((_, i) => new Date().getFullYear() - i)
                    .map((v) => (
                      <option key={v} value={v}>{`CY ${v}`}</option>
                    ))}
                </Form.Select>
              </Form.Group>

              {form.frequencyType === "Monthly" && (
                <Form.Group>
                  <Form.Label>Month</Form.Label>
                  <Form.Select name="frequencyMonth" value={form.frequencyMonth} onChange={handleChange}>
                    <option value="">Select Month</option>
                    {[
                      "January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December"
                    ].map((month, index) => (
                      <option key={index} value={index + 1}>{month}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
              <Form.Group>
                <Form.Label>Unit</Form.Label>
                <Form.Select name="unit" value={form.unit} onChange={handleChange}>
                  <option value="MT">MT</option>
                </Form.Select>
              </Form.Group>
            </div>

            <Table bordered>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Title</th>
                  <th>Unit</th>
                  <th>Current Value</th>
                  <th>Target Value</th>
                  <th>Comment</th>
                  <th>Attachment</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Total Production Quantity</td>
                  <td>MT</td>
                  <td>
                    <Form.Control
                      type="number"
                      name="currentValue"
                      value={form.currentValue}
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      name="targetValue"
                      value={form.targetValue}
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="text"
                      name="comment"
                      value={form.comment}
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="file"
                      name="attachment"
                      onChange={handleChange}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Cancel</Button>
            <Button variant="primary" onClick={handleSave}>Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Layout>
  );
};

export default observer(TotalProductionPage);